import React, { useState, useEffect, Suspense } from 'react'
import { useParams } from 'react-router-dom';
import axios from 'axios'
import { Markup } from 'interweave';
import LoadingBar from 'react-top-loading-bar'
import {Helmet} from "react-helmet";
import InfiniteScroll from "react-infinite-scroller";

import Header from '../Header/Header';
import Sidebar from '../Sidebar/Sidebar';
import Footer from '../Footer/Footer';
import Spinner from '../Global/Spinner';
import VideoBox from '../Global/VideoBox';
import ImageBox from '../Global/ImageBox';

import styles from '../../App.module.css';
import classes from './Category.module.css';

import noThumb from "../../images/no-thumb.jpg";
import EmptyContent from '../Global/EmptyContent';
import Categories from '../Categories/Categories';

function Album() {
    const  { name, id } = useParams();
    const [type, setType] = useState(null);
    const [category, setCategory] = useState([]);
    const [media, setMedia] = useState([]);
    const [hasMore, sethasMore] = useState(false);
    const [page, setpage] = useState(2);
    const [loading, setLoading] = useState(true);
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        setProgress(10);
        axios.post(`${process.env.REACT_APP_API_URL}/api/category.php`, {
            id: id,
            limit: 12
        }, {
            headers: {
                "Content-Type": "multipart/form-data",
            }
        }).then(res => {
            // console.log(res.data);
            res.data.type === 'video' && setType(1);
            res.data.type === 'music' && setType(2);
            res.data.type === 'image' && setType(3);

            setCategory({
                id: res.data.id,
                name: res.data.name,
                picture: res.data.picture,
                type: res.data.type
            });
            if(res.data.type === 'video') {
                if(res.data.videos.message !== 'No videos found') {
                    setMedia(res.data.videos);
                    res.data.videos.length < 12 ? sethasMore(false) : sethasMore(true);
                }
            }
            if(res.data.type === 'image') {
                if(res.data.images.message !== 'No images found') {
                    setMedia(res.data.images);
                    res.data.images.length < 12 ? sethasMore(false) : sethasMore(true);
                }
            }

            setLoading(true);
            setProgress(100);
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }).catch(err => {
            console.log(err);
        })
    } , [id, name])

    const loadMore = () => {
        axios.post(`${process.env.REACT_APP_API_URL}/api/category.php`, {
            id: id,
            limit: 12,
            page: page,
        }, {
            headers: {
                "Content-Type": "multipart/form-data",
            }
        }).then(res => {
            // console.log(res.data);
            if(res.data.type === 'video') {
                if(res.data.videos.message !== 'No videos found') {
                    loading && hasMore && setMedia([...media, ...res.data.videos]);
                    res.data.videos.length < 12 ? sethasMore(false) : sethasMore(true);
                    setpage(page + 1);
                }
            }
            if(res.data.type === 'image') {
                if(res.data.images.message !== 'No images found') {
                    loading && hasMore && setMedia([...media, ...res.data.images]);
                    res.data.images.length < 12 ? sethasMore(false) : sethasMore(true);
                    setpage(page + 1);
                }
            }
        }).catch(err => {
            console.log(err);
        })
    }

    return (
        <>
            {
                <Helmet>
                    <title>{category.name || 'Channel'} - Wesharez</title>
                    <meta name="description" content="Share your web pages, articles, blog entries, photographs, and videos with friends, family, and the world on Wesharez." />
                    <meta name="keywords" content="wesharez, youtube videos, musics, images, albums, earn money, Bookmarking, be a creator, share video, share your content, products, services, products and services, blog, latest articles, web pages, views, skin, science, days, review" />
                </Helmet>
            }
            <LoadingBar
                color='#f11946'
                progress={progress}
                onLoaderFinished={() => setProgress(0)}
            />
            <Header />
            <div className={styles.main_body}>
                <Suspense fallback="<div>Please wait...</div>">
                    <Sidebar />
                </Suspense>
                <Suspense fallback="<div>Please wait...</div>">
                    <div className={styles.main_content + ` main-content`}>
                        {
                            (loading && type !== null) && <Categories type={type} />
                        }
                        <div className={classes.category_component + ` p-4`}>
                            <div className={`${classes.category_head} ${classes.card}`}>
                                <div className={classes.category_picture}>
                                    <img src={category.picture} alt={category.name} />
                                </div>
                                <div className={classes.category_name}>
                                    <h3><Markup content={category.name}></Markup></h3>
                                </div>
                            </div>
                            {
                                media && media.length < 1 ? <EmptyContent /> : ''
                            }
                            {
                                category.type === 'video' && <div className={`${styles.videos} mt-4`}>
                                    {
                                        <InfiniteScroll
                                            pageStart={0}
                                            loadMore={loadMore}
                                            hasMore={hasMore}
                                            loader={<div className="loader my-4" key={0} align="center">{<Spinner />}</div>}
                                            className='row'
                                        >
                                            {
                                                
                                                media && media.map && media.map((video, index) => {
                                                    return(
                                                        <div className="col-lg-3 col-sm-6" key={index}>
                                                            {
                                                                VideoBox(video)
                                                            }
                                                        </div>
                                                    )
                                                })
                                                
                                            }
                                        </InfiniteScroll>
                                    }
                                </div>
                            }
                            {
                                category.type === 'music' && <div className={`${styles.videos} mt-4`}>
                                    {
                                        <InfiniteScroll
                                            pageStart={0}
                                            loadMore={loadMore}
                                            hasMore={hasMore}
                                            loader={<div className="loader my-4" key={0} align="center">{<Spinner />}</div>}
                                            className='row'
                                        >
                                            {
                                                
                                                media && media.map && media.map((video, index) => {
                                                    return(
                                                        <div className="col-11" key={index}>
                                                            {
                                                                VideoBox(video)
                                                            }
                                                        </div>
                                                    )
                                                })
                                                
                                            }
                                        </InfiniteScroll>
                                    }
                                </div>
                            }
                            {
                                category.type === 'image' && <div className={`${styles.gallery} mt-4`}>
                                    {
                                        <InfiniteScroll
                                            pageStart={0}
                                            loadMore={loadMore}
                                            hasMore={hasMore}
                                            loader={<div className="loader my-4" key={0} align="center">{<Spinner />}</div>}
                                            className='row'
                                        >
                                            {
                                                
                                                media && media.map && media.map((image, index) => {
                                                    return (
                                                        <div className={`${styles.item} col-lg-3 col-md-4 col-6 col-sm`} key={index}>
                                                            {
                                                                ImageBox(image)
                                                            }
                                                        </div>
                                                    )
                                                })
                                            }
                                        </InfiniteScroll>
                                    }
                                </div>
                            }
                        </div>
                        <Footer />
                    </div>
                </Suspense>
            </div>
        </>
    )
}

export default Album